// extracted by mini-css-extract-plugin
module.exports = {"container":"PortableTextRenderer_container__kncBA","normal_span":"PortableTextRenderer_normal_span__w_AwU","number_list":"PortableTextRenderer_number_list__9h9K2"};